import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import GatsbyImage from 'gatsby-image'
import classNames from 'classnames'

import { FooterQuery } from '../../types/graphql'

import * as classes from './footer.module.scss'
import logo from '../../images/btwo-logo-black.svg'

export const Footer = () => {
  const { banner, strapiFooter } = useStaticQuery<FooterQuery>(graphql`
    query Footer {
      banner: file(name: { eq: "tedx21-sponsor-footer" }) {
        childImageSharp {
          fluid(maxWidth: 2160, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    
      strapiFooter {
        office {
          address
          city
          id
          name
        }
      }
    }
  `)

  return (
    <footer id='contatti' className={classNames(['container', classes.footer])}>
      <div className={classes.label}>
        <h5>contatti</h5>
      </div>
      <div className={classes.addresses}>
        {strapiFooter?.office!.map((office) => (
          <div className={classes.info} key={office!.id!}>
            <h4>{office!.name}</h4>
            <p>
              {office!.name === 'Bologna' && (
                <>
                  LUOGO COMUNE
                  <br />
                </>
              )}
              {office!.address}
              <br />
              {office!.city}
            </p>
          </div>
        ))}

        {/* <div className={classes.banner}>
          <GatsbyImage fluid={banner.childImageSharp.fluid} />
        </div> */}

        <div className={classNames(classes.info, classes.legal)}>
          <p>
            © {new Date().getFullYear()} BTWO SRL &nbsp; P.IVA 02701970358
            &nbsp; SDI: SZLUBAI &nbsp; PEC:{' '}
            <a href='mailto: btwo@namirialpec.com'>
            btwo@namirialpec.com
            </a>{' '}
            &nbsp; <Link to='/privacy'>Privacy & cookie policy</Link>, Made in{' '}
            <a href='https://www.ventie30.it'>Ventie30</a>
          </p>
        </div>
      </div>
      <div className={classes.logo}>
        <img src={logo} alt='' />
      </div>
    </footer>
  )
}
